import omit from 'lodash/omit';

import { useRouter } from '@/hooks/useRouter';

export const useClaimsGuideModal = () => {
  const router = useRouter();

  const isModalOpen = router.query.modal === 'claims-guide';

  const onModalClose = () => {
    router.push({ query: omit(router.query, 'modal') }, undefined, {
      shallow: true,
    });
  };

  return {
    isModalOpen,
    onModalClose,
  };
};
